import React from "react";
import { useTranslation } from "react-i18next";
import { Activity } from "lucide-react";

/** Extracted verbatim from UnifiedStockerDashboard.jsx. */
const WatchlistEmptyState = ({ onAddFirstStock }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white border border-gray-200 dark:bg-slate-900/80 dark:border-slate-700/60 rounded-xl p-6 sm:p-12 text-center mb-4 sm:mb-6">
      <Activity className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-4 text-gray-500 dark:text-slate-400" />
      <h3 className="text-lg sm:text-xl font-semibold text-gray-800 dark:text-slate-200 mb-2">
        {t("dashboard.unifiedDashboard.buildYourWatchlist")}
      </h3>
      <p className="text-xs sm:text-sm text-gray-500 dark:text-slate-400">
        {t("dashboard.unifiedDashboard.buildWatchlistSubtitle")}
      </p>
      <button
        onClick={onAddFirstStock}
        className="mt-6 px-4 sm:px-6 py-2 sm:py-3 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-lg font-medium transition-colors"
      >
        {t("dashboard.unifiedDashboard.addFirstStock")}
      </button>
    </div>
  );
};

export default WatchlistEmptyState;
